var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1FBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 15L17.4275 18.2641C19.5513 19.4675 20.4487 19.4675 22.5725 18.2641L28.3333 15",
    stroke: "#003E3E",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6798 21.2297C11.7343 23.7843 11.7615 25.0616 12.7041 26.0078C13.6467 26.954 14.9586 26.9869 17.5823 27.0528C19.1994 27.0935 20.8006 27.0935 22.4177 27.0528C25.0414 26.9869 26.3532 26.954 27.2959 26.0078C28.2385 25.0616 28.2657 23.7843 28.3202 21.2297C28.3377 20.4082 28.3377 19.5917 28.3202 18.7703C28.2657 16.2157 28.2385 14.9384 27.2959 13.9922C26.3532 13.046 25.0414 13.0131 22.4177 12.9471C20.8006 12.9065 19.1994 12.9065 17.5823 12.9471C14.9586 13.013 13.6467 13.046 12.7041 13.9922C11.7615 14.9384 11.7343 16.2157 11.6798 18.7703C11.6623 19.5917 11.6623 20.4082 11.6798 21.2297Z",
    stroke: "#003E3E",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.6cc9f7df709719b25e14b358bfbd77de.svg";
export { ForwardRef as ReactComponent };